const STEPS = [
  {
    n: "01",
    title: "Discovery",
    body: "We start with the goal, not the gear. A 30-minute call to understand the mission, audience and metric of success.",
  },
  {
    n: "02",
    title: "Story & Pre-Production",
    body: "Treatment, script, shot list, casting, locations — everything locked before a single camera rolls.",
  },
  {
    n: "03",
    title: "Production",
    body: "Cinema cameras, professional sound, calm sets. We protect your time and your subjects.",
  },
  {
    n: "04",
    title: "Post & Delivery",
    body: "Edit, color, sound design, motion graphics — delivered in every aspect ratio your campaign needs.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-24 md:py-36 px-6 md:px-12 lg:px-16 border-t border-[#1a1a1a] bg-[#070707]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16 md:mb-20 reveal">
          <div>
            <p className="eyebrow text-[#E60000] mb-5">/ Process</p>
            <h2 className="font-display uppercase text-5xl md:text-7xl leading-[0.9]">
              How we<br />
              <span className="text-outline">work.</span>
            </h2>
          </div>
          <p className="md:max-w-md text-white/70 leading-relaxed md:text-lg">
            A predictable, calm process — engineered so you can focus on your
            mission while we handle the craft.
          </p>
        </div>

        <ol className="border-t border-[#1a1a1a]">
          {STEPS.map((s, i) => (
            <li
              key={s.n}
              data-testid={`process-step-${s.n}`}
              className="group grid grid-cols-12 gap-6 md:gap-12 py-8 md:py-12 border-b border-[#1a1a1a] hover:bg-[#0c0c0c] transition-colors duration-300 reveal"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="col-span-2 md:col-span-1">
                <span className="font-display text-3xl md:text-5xl text-[#E60000] leading-none">
                  {s.n}
                </span>
              </div>
              <div className="col-span-10 md:col-span-4">
                <h3 className="font-display-md uppercase text-2xl md:text-4xl leading-tight">
                  {s.title}
                </h3>
              </div>
              <div className="col-start-3 md:col-start-6 col-span-10 md:col-span-7">
                <p className="text-white/70 leading-relaxed md:text-lg max-w-xl">
                  {s.body}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
